module.exports = __webpack_public_path__ + "bz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bz.svg
// module id = 476
// module chunks = 0